<!--
 * @Author: your name
 * @Date: 2022-03-09 12:16:36
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-24 14:53:53
 * @Description: file content
-->
<template>
  <div class="modal-container">
    <div class="modal" style="height:250px">
      <div class="modal-header">
        <img src="@/assets/lottery/prize_message.svg" />
      </div>
      <div class="modal-body">
        <img src="@/assets/lottery/prize.svg" />
        <span v-cloak style="font-size:18px">{{
          prize.fonts ? prize.fonts[0].text : ""
        }}</span>
      </div>
    </div>
    <div class="modal-footer" @click="prize_get">
      <img src="@/assets/lottery/prize_get.svg" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      prize: {
        type: Object,
      },
    },
    methods: {
      prize_get(event) {
        this.$emit("prize_get", event);
      },
    },
  };
</script>

<style lang="less" scoped>
  [v-cloak] {
    display: none;
  }
  .modal-container {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 999;
    width: 100%;
    position: relative;

    .modal {
      padding-top: 11px;
      border-radius: 32px;
      background-color: snow;
      min-width: 300px;
      width: 80%;
      min-height: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .modal-header {
        flex: 2;
      }

      .modal-body {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        flex: 8;
      }
    }

    .modal-footer {
      background-color: transparent;
    }
  }
</style>
